'use strict';

const assess = require('./actionTypes/assess');
const contact = require('./actionTypes/contact');
const coordination = require('./actionTypes/coordination.json');
const documentation = require('./actionTypes/documentation.json');
const education = require('./actionTypes/education.json');
const escalation = require('./actionTypes/escalation.json');
const firstAid = require('./actionTypes/firstAid.json');
const identify = require('./actionTypes/identify.json');
const interdisciplinary = require('./actionTypes/interdisciplinary.json');
const medication = require('./actionTypes/medication.json');
const monitor = require('./actionTypes/monitor.json');
const order = require('./actionTypes/order.json');
const refer = require('./actionTypes/refer.json');
const referral = require('./actionTypes/referral.json');
const supply = require('./actionTypes/supply.json');

const actions = Object.assign(
    assess,
    contact,
    coordination,
    documentation,
    education,
    escalation,
    firstAid,
    identify,
    interdisciplinary,
    medication,
    monitor,
    order,
    refer,
    referral,
    supply
);

const actionIds = Object.keys(actions).sort();

module.exports.Actions = actions;
module.exports.ActionIds = actionIds;

module.exports = {
    Actions: actions,
    ActionIds: actionIds
};
